import styled from 'styled-components';

export const StyledLogo = styled.div`
    display: flex;
    justify-content: center;
`;

export const StyledSelectorWrapper = styled.span`
    position: absolute;
    right: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > * + * {
        margin-left: 10px;
    }

    .selector__menu {
        position: absolute;
        left: -40px;
    }
`;

export const HeaderContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;

    > span {
        margin-left: auto;
    }
`;
